module.exports = __webpack_public_path__ + "img/allianz-turkish-movie-08.0df6ab83.jpg";